// extracted by mini-css-extract-plugin
export default {"container":"Tq-z","brandName":"Uq-z","productName":"Vq-z","productNamePdpEnhancements":"Wq-z","breakLongProductName":"Xq-z"};